<template>
  <div>
    <!-- <breadcrumb v-bind:path2="path2"></breadcrumb> -->
    <div class="returns">
      <div class="main-content">
        <h2 v-if="$i18n.locale == 'en'">Return Policy</h2>
        <h2 v-if="$i18n.locale == 'ch'">退貨政策</h2>

        <div v-if="$i18n.locale == 'en'">
        <!-- <section>
          <h4>What is the return policy?</h4>
          <hr>

        <p>AFM is committed to provide our customers with a peace of mind when purchasing from us.

        If you receive products that are defective, damaged, expired, or have quality issues, you may request to return the product within the allowed return period.

        14 days of receipt of order for Food, Beverages, Snacks, Dry Goods.
        24 hours of receipt of order for Fresh Grocery and Perishables Goods.
        Due to the current COVID-19 pandemic, returns due to personal reasons are suspended.</p></section>

        <section>
        <h4>How do I return an item that was purchased from SHOPAFM.com?</h4>
        <hr>

        <p>You may request to return the product within the allowed return period by following the instructions below. AFM processes your request within 1-3 business days.

        Please email our customer service team at help@shopafm.com or (425)357-2992, or our online chat box at shopafm.com. Please be sure to provide us with your order number, picture of the product, quantity, and the reason for the return.
        Once we’ve received your email, it may take up to 3-5 business days for us to inspect and process your request.
        You do not need to ship the item back to us.</p></section> -->

        <section>
        <h4>How will I be refunded for my return?</h4>
        <hr>

        <p>The fund will be issued back to the original form of payment that the order was placed. Please note that balances can only be refunded online through your bank account</p></section>

        <section>
        <h4>Smiling Home</h4>
        <hr>

        <p>Unfortunately, we do not accept returns purchased online to be returned at store. We apologize for the inconvenience.</p></section>

        <section>
        <h4>What if the store is out of something that I ordered?</h4>
        <hr>

         <p>AFM.com customer service will contact you to see if you would like a substitute item. If you don’t want a substitute item, we will process you a refund on that item.</p></section>

        <section>
        <h4>Missing items</h4>
        <hr>

        <p>Please email our customer service team at or (425)357-2992, or our online chat box at. Please be sure to provide us with your order number, name of the missing product and quantity.</p></section>
        </div>

        <div v-if="$i18n.locale == 'ch'">
          <section>
          <h4>的退貨政策是什麼？</h4>
          <hr>

           <p>承諾在向我們購買時為客戶提供安心的服務。

          如果收到的產品有缺陷，損壞，過期或存在質量問題，則可以要求在允許的退貨期限內退貨。

          收到的食品，飲料，零食，乾貨訂單在14天內可以退貨。

          收到新鮮雜貨和易腐貨物訂單在24小時內可以退貨。

          由於當前的COVID-19大流行，由於個人原因退貨將被暫停。</p></section>

          <section>
         <h4> 如何退回從購買的商品？</h4>
         <hr>

           <p>您可以按照以下說明要求在允許的退貨期限內退貨。 會在1-3個工作日內處理您的請求。

          請通過或(425)357-2992給我們的客戶服務團隊發送電子郵件，或在上向我們的在線聊天框發送電子郵件。 請確保向我們提供您的訂單號，產品圖片，數量以及退貨原因。

          收到您的電子郵件後，我們最多可能需要3-5個工作日才能檢查和處理您的請求。

          您不需要將物品寄回給我們。</p></section>

          <section>
          <h4>如何退還我的退款？</h4>
          <hr>

           <p>資金將退還給下達訂單時的原始付款方式。 請注意，餘額只能通過您的銀行帳戶在線退款</p></section>

          <section>
          <h4>我可以將購買的到百家超市線下門店退款嗎？</h4>
          <hr>

           <p>不幸的是，我們不接受在線購買的退貨到百家超市線下門店退貨。 我們對不便表示抱歉。</p></section>

          <section>
          <h4>如果我訂購的東西在網店中缺貨怎麼辦？</h4>
          <hr>

           <p>客戶服務將與您聯繫，以查看是否需要替代品。 如果您不希望使用替代品，我們將為您退款。</p></section>

          <section>
          <h4>丟失物品</h4>
          <hr>

          <p>請通過或(425)357-2992給我們的客戶服務團隊發送電子郵件，或在上向我們的在線聊天框發送電子郵件。 請確保向我們提供您的訂單號，缺少的產品名稱和數量。</p></section>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import breadcrumb from '../components/breadcrumb'

export default {
  name: "returns",
  components: {
    breadcrumb,
  },
  data() {
    return {
      path2: 'Returns and Refunds',
    }
  },
}
</script>

<style scoped lang="less">
@import "../assets/css/public.less";
@import "../assets/css/returns.less";
</style>



// WEBPACK FOOTER //
// src/view/returnsAndRefunds.vue